/* Custom-configurator: designs gallery, save/share, nearby pins, deep-link, feedback.
 *
 * Shared VERBATIM by both custom builders (since 2026-10-25 one section,
 * cc_custom_configurator_v3, for the Custom CUBE and the Custom FRAME). It lives
 * here rather than inline in the section for two reasons:
 *
 *  1. Size. A Liquid section may not exceed 256 KB and both sections were within
 *     a few KB of that ceiling. Moving these ~45 KB out gives each ~35 KB of room
 *     (and the browser now CDN-caches this instead of re-downloading it inside
 *     every page's HTML).
 *  2. Duplication. These blocks were byte-identical apart from three product
 *     tokens, so every fix had to be applied twice and could silently drift.
 *     PRODUCT (below) is the only product-specific thing left in here.
 *
 * Contains NO Liquid — all configuration is read from window.CF.* (SAVE, NEARBY,
 * MAINCOLL, CONSTANTS, T, EXISTING_LOCATIONS), which the sections set inline
 * BEFORE loading this file. Keep it that way: it must stay a plain asset.
 *
 * Load order matters. The sections include it with `| script_tag`, which is
 * parser-blocking and runs in document order, so it still executes after the
 * inline window.CF setup exactly as it did when it was inline.
 */
(() => {
document.addEventListener('DOMContentLoaded', () => {
  const stepsRoot   = document.getElementById('cf-v2-steps');
  const configRoot  = document.getElementById('cube-custom-configurator');
  const previewBtn  = document.getElementById('cube-custom-get-preview');
  const changeBtn   = document.getElementById('cube-custom-change-location');
  const continueBtn = document.getElementById('cf-v2-continue-btn');

  function setActiveStep(n) {
    if (!stepsRoot) return;
    stepsRoot.querySelectorAll('.cf-v2-step').forEach(el => {
      const s = Number(el.dataset.v2Step);
      el.classList.toggle('is-active', s === n);
      el.classList.toggle('is-done',   s <  n);
    });
  }

  function setStepsClickable(previewReady) {
    if (!stepsRoot) return;
    stepsRoot.querySelectorAll('.cf-v2-step').forEach(el => {
      const s = Number(el.dataset.v2Step);
      const clickable = s === 1 || previewReady;
      el.classList.toggle('is-clickable', clickable);
      el.classList.toggle('is-disabled', !clickable);
    });
  }

  function syncStepFromView() {
    if (!configRoot) return;
    if (configRoot.classList.contains('cc-custom-view-customize')) setActiveStep(3);
    else if (configRoot.classList.contains('cc-custom-view-preview')) setActiveStep(2);
    else setActiveStep(1);
    setStepsClickable(configRoot.classList.contains('is-preview-ready'));
  }

  if (configRoot) {
    const obs = new MutationObserver(syncStepFromView);
    obs.observe(configRoot, { attributes: true, attributeFilter: ['class'] });
    syncStepFromView();
  }

  function goToView(view) {
    if (!configRoot) return;
    configRoot.classList.toggle('cc-custom-view-location',  view === 'location');
    configRoot.classList.toggle('cc-custom-view-preview',   view === 'preview');
    configRoot.classList.toggle('cc-custom-view-customize', view === 'customize');
    if (view === 'customize') window.CF_CUBE_CUSTOM_onEnterCustomize?.();
    else window.CF_CUBE_CUSTOM_onLeaveCustomize?.();
    requestAnimationFrame(() => window.CF_CUBE_CUSTOM_MAP?.resize?.());
  }

  if (stepsRoot) {
    stepsRoot.addEventListener('click', (event) => {
      const stepEl = event.target.closest('.cf-v2-step');
      if (!stepEl || stepEl.classList.contains('is-disabled')) return;
      const n = Number(stepEl.dataset.v2Step);
      if (n === 3 && configRoot.classList.contains('is-height-exceeded')) return;
      if (n === 1)      goToView('location');
      else if (n === 2) goToView('preview');
      else if (n === 3) goToView('customize');
    });
  }

  if (previewBtn) {
    previewBtn.addEventListener('click', () => setActiveStep(2));
  }

  if (changeBtn) {
    changeBtn.addEventListener('click', () => setActiveStep(1));
  }

  if (continueBtn && configRoot) {
    continueBtn.addEventListener('click', () => {
      if (configRoot.classList.contains('is-height-exceeded')) return;   // blocked: model exceeds 15 cm
      goToView('customize');
      // No scroll on a phone (2026-10-16): the last step opens where the reader is, with the steps, the name, the
      // price, the add-ons and the button in view. The scroll to the add-ons' old box did nothing since the custom
      // CUBE's add-ons moved into the purchase block, and scrolling to that block hid the name and price above it.
    });
  }

  const step3BackBtn = document.getElementById('cc-step3-back-btn');
  if (step3BackBtn) step3BackBtn.addEventListener('click', () => goToView('preview'));

  const fromPrefix = document.getElementById('cf-v2-price-prefix');

  function syncFromPrefix() {
    if (!fromPrefix) return;
    const inCustomize = configRoot && configRoot.classList.contains('cc-custom-view-customize');
    fromPrefix.style.display = inCustomize ? 'none' : '';
  }

  if (configRoot) {
    const obs2 = new MutationObserver(syncFromPrefix);
    obs2.observe(configRoot, { attributes: true, attributeFilter: ['class'] });
    syncFromPrefix();
  }
});
})();
(() => {
const CFG = (window.CF && window.CF.SAVE) || {};
if (!CFG.enabled) return;

// Which product this page configures, read from the section root. This file is
// shared by BOTH configurators, so everything product-specific is derived from
// this one value instead of living twice in two 260 KB section files.
const PRODUCT    = document.getElementById('cube-custom-configurator')?.dataset.cfProduct || 'cube';
const BUFFER_KEY = `cf_${PRODUCT}_designs_r1`;   // per-product draft buffer
const BUFFER_CAP = 25;              // max designs kept locally (FIFO, no wall)
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function readBuffer() {
  try { return JSON.parse(localStorage.getItem(BUFFER_KEY)) || []; }
  catch (_) { return []; }
}
function writeBuffer(list) {
  try { localStorage.setItem(BUFFER_KEY, JSON.stringify(list.slice(-BUFFER_CAP))); }
  catch (_) { }
}
function addToBuffer(entry) {
  if (!entry || !entry.design_id) return;
  const list = readBuffer().filter(d => d.design_id !== entry.design_id);  // dedupe by design_id
  list.push(entry);
  writeBuffer(list);
}
function dropGone(designId) {
  const list = readBuffer();
  const kept = list.filter(d => d.design_id !== designId);
  if (kept.length !== list.length) { writeBuffer(kept); renderGallery(); }
}

async function verifyOrDrop(d, img) {
  const base = CFG.proxyPath || CFG.apiUrl;
  if (base && d.design_id) {
    try {
      const res = await fetch(`${base}/img/${d.design_id}/preview.jpg`, { method: 'HEAD', cache: 'no-store' });
      if (res.status === 404) { dropGone(d.design_id); return; }
    } catch (_) { }
  }
  if (d.preview_url && img && img.src !== d.preview_url) img.src = d.preview_url;
}

function buildEntry(src) {
  const preview = src || window.CF_CUBE_CUSTOM_PREVIEW;
  if (!preview || !preview.design_id) return null;
  const mapState = window.CF_CUBE_CUSTOM_MAP?.getState?.() || {};
  const center = mapState.center || {};
  const placeEl = document.getElementById('cube-custom-location-place');
  const cfg = (typeof cfReadLiveConfig === 'function') ? cfReadLiveConfig() : {};
  return {
    design_id:  preview.design_id,
    preview_url: preview.preview_url || '',
    place_name: (placeEl?.textContent || '').trim(),
    lat: center.lat, lon: center.lng,
    scale: mapState.scale, rotation: mapState.rotation,
    // The geocoded place, in parts. `place_name` is "City, Country" for a
    // heading; these are what another surface needs to label the design the way
    // a catalogue city is labelled - the bundle configurator's plaque
    // auto-fill offers "Country name" and "City, CC" and cannot split a
    // sentence back into them. getState() has carried these all along.
    city: mapState.city || '',
    country: mapState.country || '',
    country_code: mapState.countryCode || '',
    area: mapState.area || '',
    created_at: new Date().toISOString(),
    saved: false,
    // Configuration snapshot so reopening this design restores the selections.
    trees: !!preview.trees,
    streets: !!preview.streets,
    cover: cfg.cover || 'none',
    plaque: cfg.plaque || 'none',
    plaque_headline: cfg.plaque_headline || '',
    plaque_subheadline: cfg.plaque_subheadline || '',
    marker: cfg.marker || null,
  };
}

// Keep a saved draft's config in sync as the shopper changes selections (called
// from the debounced server autosave) so a same-browser reopen restores the
// latest state — not the snapshot captured at generation time.
window.CF.updateDesignBufferConfig = function (designId, cfg) {
  if (!designId || !cfg) return;
  const buf = readBuffer();
  let touched = false;
  buf.forEach((d) => {
    if (d.design_id === designId) {
      d.trees = !!cfg.trees; d.streets = !!cfg.streets;
      d.cover = cfg.cover || 'none'; d.plaque = cfg.plaque || 'none';
      d.plaque_headline = cfg.plaque_headline || '';
      d.plaque_subheadline = cfg.plaque_subheadline || '';
      if ('marker' in cfg) d.marker = cfg.marker;
      touched = true;
    }
  });
  if (touched) writeBuffer(buf);
};

const galleryWrap = document.getElementById('cc-gallery-wrap');
const galleryEl   = document.getElementById('cc-gallery');
const viewDesignsBtn = document.getElementById('cube-custom-view-designs');
const viewDesignsBtnTop = document.getElementById('cube-custom-view-designs-top');

const activeDesignId = () => window.CF_CUBE_CUSTOM_PREVIEW?.design_id || null;

// ── "Available from our main collection" row ────────────────────────────
// Catalogue CUBEs within a medium radius of the ACTIVE design. Rendered from
// renderGallery() (below), so it re-computes on every design switch/add/remove.
const MAINCOLL = (window.CF && window.CF.MAINCOLL) || {};
const maincollSection = document.getElementById('cc-maincoll');
const maincollList    = document.getElementById('cc-maincoll-list');
const MAINCOLL_RADIUS_KM = Number(MAINCOLL.radiusKm) || 25;
const MAINCOLL_MAX       = Number(MAINCOLL.max) || 6;
// Tight radius for the "already covered" gate: if a design is generated this
// close to an existing model, the generate modal offers that model first.
const MAINCOLL_ALERT_RADIUS_KM = Number(MAINCOLL.alertRadiusKm) || 1;

// DMS ("50°6'52\"N 8°40'56\"E") → {lat, lon}. Self-contained copy of the
// map-pin IIFE's parseDMS so this row stays independent of it.
function parseCoord(str) {
  if (!str) return null;
  const re = /(\d+(?:\.\d+)?)\s*°\s*(?:(\d+(?:\.\d+)?)\s*['′])?\s*(?:(\d+(?:\.\d+)?)\s*["″])?\s*([NSEWnsew])/g;
  const parts = [];
  let m;
  while ((m = re.exec(str)) && parts.length < 2) {
    let dec = (parseFloat(m[1]) || 0) + (parseFloat(m[2]) || 0) / 60 + (parseFloat(m[3]) || 0) / 3600;
    const hemi = m[4].toUpperCase();
    if (hemi === 'S' || hemi === 'W') dec = -dec;
    parts.push({ dec, hemi });
  }
  if (parts.length < 2) return null;
  let lat = null, lon = null;
  parts.forEach(p => { if (p.hemi === 'N' || p.hemi === 'S') lat = p.dec; else lon = p.dec; });
  return (lat === null || lon === null) ? null : { lat, lon };
}
function haversineKm(aLat, aLon, bLat, bLon) {
  const R = 6371, toR = (x) => x * Math.PI / 180;
  const dLat = toR(bLat - aLat), dLon = toR(bLon - aLon);
  const s = Math.sin(dLat / 2) ** 2 + Math.cos(toR(aLat)) * Math.cos(toR(bLat)) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
}
const MAINCOLL_LOCS = (window.CF && window.CF.EXISTING_LOCATIONS ? window.CF.EXISTING_LOCATIONS : [])
  .map((l) => { const c = parseCoord(l.coordinates); return c ? { ...l, lat: c.lat, lon: c.lon } : null; })
  .filter(Boolean);

function nearbyModels(lat, lon) {
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return [];
  return MAINCOLL_LOCS
    .map((l) => ({ l, d: haversineKm(lat, lon, l.lat, l.lon) }))
    .filter((x) => x.d <= MAINCOLL_RADIUS_KM)
    .sort((a, b) => a.d - b.d)
    .slice(0, MAINCOLL_MAX)
    .map((x) => x.l);
}

// The single nearest existing model within the tight "already covered" radius,
// or null. Exposed for the generate gate (handleGetPreview shows the modal).
window.CF.nearestAlertModel = function (lat, lon) {
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  let best = null, bestD = Infinity;
  for (const l of MAINCOLL_LOCS) {
    const d = haversineKm(lat, lon, l.lat, l.lon);
    if (d <= MAINCOLL_ALERT_RADIUS_KM && d < bestD) { best = l; bestD = d; }
  }
  return best;
};

// ── THE CARDS (2026-10-16, Alex) ─────────────────────────────────────────
// "Your Designs" and the main-collection row are the store's tile cards: the
// section prints one empty design card (snippets/cf-design-card) in
// <template data-cc-design-card>, and both rows clone it. A design card picks
// that design (ring + "Selected" on the one on screen, "Select" on the
// others); a main-collection card is a catalogue CUBE/FRAME and links to it.
const cardTemplate = document.querySelector('template[data-cc-design-card]');
const T_CARD = (window.CF && window.CF.T && window.CF.T.cube_custom) || {};

function cloneCard() {
  const source = cardTemplate && cardTemplate.content.firstElementChild;
  return source ? source.cloneNode(true) : null;
}

// A flag from a geocoded ISO code, as the catalogue tiles carry one after the name.
function flagFor(code) {
  const c = String(code || '').trim().toUpperCase();
  return /^[A-Z]{2}$/.test(c) ? String.fromCodePoint(...Array.from(c, (l) => 0x1f1e6 + l.charCodeAt(0) - 65)) : '';
}

function setFlag(card, code, label) {
  const slot = card.querySelector('[data-cf-design-flag]');
  if (!slot) return;
  const flag = flagFor(code);
  if (!flag) { slot.remove(); return; }
  slot.textContent = flag;
  slot.setAttribute('aria-label', label || code);
  slot.setAttribute('title', label || code);
  slot.removeAttribute('hidden');
}

function buildMainCollCard(m) {
  const card = cloneCard();
  if (!card) return null;
  const cell = document.createElement('div');
  cell.className = 'cc-maincoll__cell';
  cell.setAttribute('role', 'listitem');
  cell.appendChild(card);

  card.querySelectorAll('[data-cf-design-link]').forEach((a) => a.setAttribute('href', m.url || '#'));
  const raw = (m.name || '').trim();
  const di = raw.indexOf('-');
  const city = di >= 0 ? raw.slice(0, di).trim() : raw;
  const area = di >= 0 ? raw.slice(di + 1).trim() : '';

  const img = card.querySelector('[data-cf-design-image]');
  if (img) {
    img.src = m.img || m.imgSmall || '';
    img.alt = raw;
    img.removeAttribute('srcset');
  }
  const cityLine = card.querySelector('[data-cf-design-city]');
  if (cityLine) cityLine.textContent = city;
  setFlag(card, '', '');
  const sub = card.querySelector('.product-card__sub');
  if (sub) sub.textContent = area;
  // The catalogue model's own price, written as every price on the page (window.cfPrice).
  const amount = card.querySelector('.price-list__amount');
  if (amount && Number.isFinite(Number(m.price)) && typeof window.cfPrice === 'function') amount.textContent = window.cfPrice(Number(m.price));
  const label = card.querySelector('.product-card__action-label');
  if (label) label.textContent = T_CARD.view_model || 'View';
  return cell;
}

let maincollKey = null;
function renderMainCollection(active) {
  if (!maincollSection || !maincollList) return;
  const models = active ? nearbyModels(Number(active.lat), Number(active.lon)) : [];
  // The same models as last time: leave the cards alone (no re-render, no blink).
  const key = models.map((m) => m.url || m.name).join('|');
  if (key === maincollKey && maincollList.childElementCount) { maincollSection.hidden = !models.length; return; }
  maincollKey = key;
  maincollList.textContent = '';
  if (!models.length) { maincollSection.hidden = true; return; }
  models.forEach((m) => { const c = buildMainCollCard(m); if (c) maincollList.appendChild(c); });
  maincollSection.hidden = false;
}

function galleryDesigns() {
  return readBuffer().slice().sort((a, b) =>
    (Date.parse(b.created_at || 0) || 0) - (Date.parse(a.created_at || 0) || 0));
}

function flipTo(d) {
  if (!d) return;
  window.CF.CUBE_PREVIEW?.showDesign?.(d);
  renderGallery();
}

// Explicit "cancel this generating design". The ONLY path that stops a render
// the shopper didn't ask to keep: it cancels server-side AND drops the notifier
// registry entry, so no toast keeps polling a job nobody is waiting for. If the
// inline overlay was following it, fall back to the map.
function removePending(d) {
  if (!d || !d.design_id) return;
  window.CF.cancelRender(d.design_id);
  window.CF_NOTIFY?.clear(d.design_id);
  if (window.CF.CUBE_PREVIEW?.watchedPendingId?.() === d.design_id) {
    window.CF.CUBE_PREVIEW?.clear?.();
  }
  renderGallery();
}

function removeDesign(d) {
  if (!d) return;
  window.CF.cancelRender(d.design_id);   // stop its render compute if still running on the server
  const wasActive = d.design_id === activeDesignId();
  writeBuffer(readBuffer().filter(x => x.design_id !== d.design_id));   // drop the local draft only
  if (wasActive) {
    const next = galleryDesigns()[0];
    if (next) flipTo(next);
    else window.CF.CUBE_PREVIEW?.clear?.();
  }
  renderGallery();
}

const designName = (d) => (d.label || '').trim() || (d.place_name || '').trim() || 'Design';
// City only — place names are reverse-geocoded as "City, Country[, …]"; the
// gallery card shows just the first (city) segment, no country.
const cityName = (d) => designName(d).split(',')[0].trim() || designName(d);

// Fill a gallery thumbnail with the design's step-3 product-shot — the REGULAR
// (model) composite. Until it's ready the box holds the empty frame + pulse
// (.is-loading). We poll ONLY the sized `addon-400.jpg`: NEVER `addon.jpg`,
// because the API's /img route serves the angled hero (preview.jpg) for
// `addon.jpg` before the composite exists (save_api fallback) — that's what
// flashed the wrong image. `addon-400.jpg` has no such fallback, so it 404s
// honestly until the real shot lands. Cache-bust every probe so a 404 cached
// mid-render doesn't stick; give up + verify existence after a couple minutes.
// design_id -> the step-3 shot already loaded in this visit.
const shotCache = new Map();

function upgradeThumbToAddon(img, box, d) {
  const designId = d && d.design_id;
  if (!CFG.apiUrl || !designId || !img) return;
  // f=45: the shot turned 4:5 on 2026-10-01 under the same name; a new URL is never served stale.
  const small = `${CFG.apiUrl}/img/${encodeURIComponent(designId)}/addon-400.jpg?f=45`;
  let tries = 0;
  const poll = () => {
    const u = `${small}&t=${tries}`;
    const probe = new Image();
    probe.onload = () => {
      img.src = u;
      shotCache.set(designId, u);   // a card built again starts on it: no flash of the empty frame
      if (box) box.classList.remove('is-loading');   // product shot in → stop the pulse
    };
    probe.onerror = () => {
      if (img.isConnected === false && tries > 0) return;   // card replaced → stop polling
      if (++tries >= 24) { verifyOrDrop(d, img); return; }   // ~2 min, then verify it exists
      setTimeout(poll, 5000);
    };
    probe.src = u;
  };
  poll();
}

// The part of a design card that follows the selection: the ring round the
// design on screen (theme's text colour, see cc-custom-configurator-v3.css).
function applySelection(card, selected) {
  card.classList.toggle('is-selected', selected);
  card.setAttribute('aria-current', selected ? 'true' : 'false');
}

function buildThumb(d, activeId) {
  const card = cloneCard();
  if (!card) return null;
  const cell = document.createElement('div');
  cell.className = 'cc-gallery__cell' + (d.pending ? ' is-pending' : '');
  cell.setAttribute('role', 'listitem');
  cell.dataset.designId = d.design_id || '';
  cell.appendChild(card);
  card.classList.add('cc-design-tile');
  // No button: the whole card picks the design (Alex, 2026-10-30: the "Select" buttons removed, on the CUBE's and
  // the FRAME's; 2026-10-16 had already dropped the "Selected" one).
  card.querySelector('.product-card__action')?.remove();
  if (d.pending) card.classList.add('is-pending');

  // The links keep the design's own address (a new tab opens it), but a plain
  // click picks it here: a finished design comes up on screen, a generating one
  // points the progress overlay at itself (watchPending only attaches - it never
  // starts or cancels a render).
  card.querySelectorAll('[data-cf-design-link]').forEach((a) => a.setAttribute('href', designLink(d)));
  card.addEventListener('click', (e) => {
    if (e.target.closest('.cc-gallery__del')) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    e.preventDefault();
    if (d.pending) {
      window.CF.CUBE_PREVIEW?.watchPending?.(d.design_id, { place_name: d.place_name });
      renderGallery();
    } else {
      flipTo(d);
    }
  });

  const figure = card.querySelector('.product-card__figure');
  const img = card.querySelector('[data-cf-design-image]');
  const box = img && img.parentElement;
  if (img) {
    img.alt = designName(d);
    img.removeAttribute('srcset');
    const shot = shotCache.get(d.design_id);
    if (shot && !d.pending) {
      img.src = shot;
    } else {
      // The empty frame, pulsing, until the step-3 shot lands (never the angled map-step render).
      img.src = document.getElementById('cube-custom-addon-img')?.dataset.placeholder || '';
      if (box) box.classList.add('is-loading');
      if (!d.pending) upgradeThumbToAddon(img, box, d);
    }
  }
  if (d.pending && figure) {
    const sp = document.createElement('div');
    sp.className = 'cc-gallery__spinner';
    figure.appendChild(sp);
  }

  // × - deletes a finished design (the local draft only); on a generating one it
  // is the one place that DOES cancel the render, and drops the notifier entry.
  const del = document.createElement('button');
  del.type = 'button';
  del.className = 'cc-gallery__del';
  del.setAttribute('aria-label', d.pending ? 'Cancel design' : 'Delete design');
  del.title = T_CARD.del_title || 'Delete';
  del.textContent = '×';
  del.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); d.pending ? removePending(d) : removeDesign(d); });
  if (figure) figure.appendChild(del);

  const cityLine = card.querySelector('[data-cf-design-city]');
  if (cityLine) { cityLine.textContent = d.city || cityName(d); cityLine.title = designName(d); }
  setFlag(card, d.country_code, d.country);

  applySelection(card, d.design_id === activeId);
  return cell;
}

// Cards for designs still generating. THE notifier registry (cf_pending_designs)
// is the single source of truth for these — it survives navigation, and every
// pending card therefore has a REAL design_id.
//
// There used to be a second, session-only placeholder (`pendingEntry`, id
// '__pending__') created on cf:cube:preview-start and cleared on
// cf:design:registered. Resuming an already-registered design never re-fired
// that event, so the placeholder stuck around NEXT TO the registry's card for
// the same job: two "generating" cards for one render, the phantom one labelled
// from the DOM's default place ("Berlin, Germany") because the reverse-geocode
// had not landed yet. That is gone — one job, one card, labelled from the
// registry's own recorded title.
function pendingPlaceholders() {
  const out = [];
  try {
    const reg = JSON.parse(localStorage.getItem('cf_pending_designs')) || [];
    const inBuffer = new Set(readBuffer().map(d => d.design_id));
    const seen = new Set();
    reg.forEach(r => {
      if (!r || r.product !== PRODUCT || r.notified || inBuffer.has(r.id)) return;
      if (seen.has(r.id)) return;   // never render one design twice
      seen.add(r.id);
      out.push({ design_id: r.id, pending: true, place_name: r.title || '', label: '',
                 lat: r.lat, lon: r.lon, scale: r.scale, rotation: r.rotation,
                 created_at: new Date(r.startedAt || Date.now()).toISOString() });
    });
  } catch (_) {}
  return out.sort((a, b) => (b.created_at || '').localeCompare(a.created_at || ''));
}

let galleryKey = null;
function renderGallery() {
  if (!galleryEl) return;
  const list = galleryDesigns();   // this session's drafts, newest-first
  const display = [...pendingPlaceholders(), ...list];
  if (galleryWrap) galleryWrap.classList.toggle('has-designs', display.length > 0);
  if (viewDesignsBtn) viewDesignsBtn.hidden = display.length === 0;
  if (viewDesignsBtnTop) viewDesignsBtnTop.hidden = display.length === 0;
  // A finished design is "active" when it's the one being previewed; a pending
  // one when the inline overlay is following its render.
  const activeId = activeDesignId() || window.CF.CUBE_PREVIEW?.watchedPendingId?.() || null;
  // The same designs in the same states as last time: only the selection moves.
  // Rebuilding every card on a click put each picture back on the empty frame
  // until its shot reloaded - the whole row blinked.
  const key = display.map(d => (d.pending ? 'p:' : 'd:') + d.design_id).join('|');
  if (key === galleryKey && galleryEl.childElementCount === display.length) {
    galleryEl.querySelectorAll('.cc-gallery__cell').forEach((cell) => {
      const card = cell.querySelector('.cc-design-tile');
      if (card) applySelection(card, cell.dataset.designId === activeId);
    });
  } else {
    galleryKey = key;
    galleryEl.textContent = '';
    display.forEach(d => { const c = buildThumb(d, activeId); if (c) galleryEl.appendChild(c); });
  }
  // Per-design "main collection" row: nearby catalogue CUBEs for the active design.
  renderMainCollection(display.find(d => d.design_id === activeId && !d.pending));
}

window.CF.SESSION = {
  guardGenerate() { return true; },
};

document.addEventListener('cf:cube:preview-ready', (e) => {
  const entry = buildEntry(e.detail);
  if (entry) addToBuffer(entry);
  renderGallery();
});
// The pending set changed — a design was registered, gave up, or the overlay
// switched to following a different one. Re-render so the cards and their
// active state agree with reality.
document.addEventListener('cf:design:registered', renderGallery);
document.addEventListener('cf:cube:preview-cancelled', renderGallery);
// The global notifier buffered a design that finished while the shopper was away
// (see snippets/cf-design-notify) — re-render so it shows in "Your Designs" now.
document.addEventListener('cf:design:buffered', () => renderGallery());
document.addEventListener('DOMContentLoaded', renderGallery);
renderGallery();

const captureEl    = document.getElementById('cc-save-capture');
const emailInput   = document.getElementById('cc-save-email');
const confirmBtn   = document.getElementById('cc-save-confirm');
const statusEl     = document.getElementById('cc-save-status');
const newsBox      = captureEl?.querySelector('input[name="cc-save-news"]');
const EMAIL_STORE  = 'cf_cube_email';
let pendingSave    = null;

const rememberedEmail = () => { try { return localStorage.getItem(EMAIL_STORE) || ''; } catch (_) { return ''; } };
const rememberEmail   = (e) => { try { localStorage.setItem(EMAIL_STORE, e); } catch (_) {} };

function setStatus(msg, kind) {
  if (!statusEl) return;
  statusEl.textContent = msg || '';
  statusEl.hidden = !msg;
  statusEl.classList.toggle('is-error', kind === 'error');
  statusEl.classList.toggle('is-success', kind === 'success');
}

function openCapture() { if (captureEl) { captureEl.hidden = false; setStatus(''); emailInput?.focus(); } }
function closeCapture() { if (captureEl) captureEl.hidden = true; }

async function postEmail(designs, email) {
  const base = CFG.proxyPath || CFG.apiUrl;
  if (!base) throw new Error('Not available right now.');
  // configurator_url: this page, so the email links back to the configurator the
  // shopper is actually on (the backend same-origin-validates it). No marketing_consent —
  // "Email this design" just sends the design, it's not a newsletter signup.
  const payload = { designs, email, notify: true, configurator_url: location.origin + location.pathname };
  const res = await fetch(`${base}/design/save`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  if (!res.ok) { const b = await res.json().catch(() => ({})); throw new Error(b.detail || `Server error ${res.status}`); }
}

// ── Email / Share / Copy actions on the ACTIVE (currently-previewed) design ──
const T_ACT = (window.CF && window.CF.T && window.CF.T.cube_custom) || {};

function activeDesign() {
  const id = activeDesignId();
  if (!id) return null;
  const fromBuf = galleryDesigns().find((d) => d.design_id === id);
  if (fromBuf) return fromBuf;
  const p = window.CF_CUBE_CUSTOM_PREVIEW;   // fall back to the live preview object
  return (p && p.design_id === id)
    ? { design_id: p.design_id, lat: p.lat, lon: p.lon, scale: p.scale, rotation: p.rotation }
    : null;
}

// Shareable deep link. design= leads — the configurator resolves it to THIS
// exact design (see the deep-link block below); the coordinates ride along as
// the regenerate-from-scratch fallback. Keep both.
function designLink(d) {
  const u = new URL(location.origin + location.pathname);
  if (d.design_id)                 u.searchParams.set('design', d.design_id);
  if (Number.isFinite(d.lat))      u.searchParams.set('lat', d.lat);
  if (Number.isFinite(d.lon))      u.searchParams.set('lon', d.lon);
  if (Number.isFinite(d.scale))    u.searchParams.set('scale', d.scale);
  if (Number.isFinite(d.rotation)) u.searchParams.set('rotation', d.rotation);
  u.searchParams.set('saved', '1');
  return u.toString();
}

function copyText(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text).then(() => true).catch(() => false);
  }
  try {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.focus(); ta.select();
    const ok = document.execCommand('copy'); document.body.removeChild(ta);
    return Promise.resolve(ok);
  } catch (_) { return Promise.resolve(false); }
}

// Transient label swap ("Sent" / "Copied!") on a text link, then restore. A link with an icon keeps it: only
// its label span changes.
function flashLink(btn, msg) {
  if (!btn) return;
  const el = btn.querySelector('.cf-action__label') || btn;
  if (!btn.dataset.label) btn.dataset.label = el.textContent;
  el.textContent = msg;
  clearTimeout(btn._t);
  btn._t = setTimeout(() => { el.textContent = btn.dataset.label; }, 2500);
}

async function emailActiveDesign(btn) {
  const d = activeDesign();
  if (!d) return;
  const email = rememberedEmail();
  if (!email) { pendingSave = d; openCapture(); return; }   // first time → ask for email
  try {
    await postEmail([d], email);
    flashLink(btn, T_ACT.action_sent || 'Sent ✓');
  } catch (err) {
    setStatus(err.message || T_ACT.save_error || 'Could not send. Please try again.', 'error');
  }
}

async function shareActiveDesign(btn) {
  const d = activeDesign();
  if (!d) return;
  const url = designLink(d);
  if (navigator.share) {
    try { await navigator.share({ title: document.title, url }); } catch (_) { /* cancelled */ }
  } else {
    await copyText(url);
    flashLink(btn, T_ACT.action_copied || 'Link copied ✓');
  }
}

async function copyActiveDesignLink(btn) {
  const d = activeDesign();
  if (!d) return;
  const ok = await copyText(designLink(d));
  flashLink(btn, ok ? (T_ACT.action_copied || 'Link copied ✓') : 'Copy failed');
}

async function handleCaptureSubmit() {
  const email = (emailInput?.value || '').trim();
  if (!EMAIL_RE.test(email)) { setStatus((window.CF?.T?.cube_custom?.email_invalid || 'Please enter a valid email address.'), 'error'); emailInput?.focus(); return; }
  const designs = pendingSave ? [pendingSave] : [];
  if (!designs.length) { closeCapture(); return; }
  if (confirmBtn) confirmBtn.disabled = true;
  setStatus('Sending…', null);
  try {
    await postEmail(designs, email);
    rememberEmail(email);                        // entered once → next designs send in one tap
    // The news tick box: the same sign-up as the newsletter forms (snippets/cf-newsletter-form), so
    // Klaviyo sends its confirmation email first. Best effort - the design went out either way.
    if (newsBox?.checked) window.cfNewsletterSubscribe?.({ email, source: 'Custom Location' }).catch(() => {});
    pendingSave = null;
    closeCapture();
    setStatus(T_ACT.action_sent || 'Sent ✓', 'success');
  } catch (err) {
    setStatus(err.message || window.CF?.T?.cube_custom?.save_error || 'Could not send. Please try again.', 'error');
    if (confirmBtn) confirmBtn.disabled = false;
  }
}

if (confirmBtn) confirmBtn.addEventListener('click', handleCaptureSubmit);

// Email / Share / Copy-link actions for the active design (below MAP/CONTINUE).
document.getElementById('cc-action-email')?.addEventListener('click', (e) => emailActiveDesign(e.currentTarget));
document.getElementById('cc-action-share')?.addEventListener('click', (e) => shareActiveDesign(e.currentTarget));
document.getElementById('cc-action-copy')?.addEventListener('click', (e) => copyActiveDesignLink(e.currentTarget));

function openLatestDesign() {
  const d = galleryDesigns()[0];
  if (d) flipTo(d);
}
if (viewDesignsBtn) viewDesignsBtn.addEventListener('click', openLatestDesign);
if (viewDesignsBtnTop) viewDesignsBtnTop.addEventListener('click', openLatestDesign);
})();
(() => {
function init() {
const NEARBY = (window.CF && window.CF.NEARBY) || {};
const RAW = (window.CF && window.CF.EXISTING_LOCATIONS) || [];
if (!NEARBY.enabled || !RAW.length) return;

const RADIUS_KM = Number(NEARBY.radiusKm) || 1;

function parseDMS(str) {
  if (!str) return null;
  const re = /(\d+(?:\.\d+)?)\s*°\s*(?:(\d+(?:\.\d+)?)\s*['′])?\s*(?:(\d+(?:\.\d+)?)\s*["″])?\s*([NSEWnsew])/g;
  const parts = [];
  let m;
  while ((m = re.exec(str)) && parts.length < 2) {
    const deg = parseFloat(m[1]) || 0;
    const min = parseFloat(m[2]) || 0;
    const sec = parseFloat(m[3]) || 0;
    let dec = deg + min / 60 + sec / 3600;
    const hemi = m[4].toUpperCase();
    if (hemi === 'S' || hemi === 'W') dec = -dec;
    parts.push({ dec, hemi });
  }
  if (parts.length < 2) return null;
  let lat = null, lon = null;
  parts.forEach(p => { if (p.hemi === 'N' || p.hemi === 'S') lat = p.dec; else lon = p.dec; });
  if (lat === null || lon === null) return null;
  return { lat, lon };
}

const LOCS = RAW.map(loc => {
  const c = parseDMS(loc.coordinates);
  return c ? { name: loc.name, img: loc.img, imgSmall: loc.imgSmall || loc.img, url: loc.url, magnetic: loc.magnetic || '', lat: c.lat, lon: c.lon } : null;
}).filter(Boolean);
if (!LOCS.length) return;

// Below this zoom we hide all pins to avoid clutter when zoomed out to
// continent level (the catalogue spans ~200 cities worldwide). Only the pins
// inside the current view are ever mounted, capped at MAX_PINS, so a lower
// threshold keeps them visible further out without cluttering / slowing the map.
const MIN_ZOOM = 5;
const MAX_PINS = 60;

const markers = new Map();   // url -> mapboxgl.Marker (only for in-view locations)

function splitName(raw) {
  const r = (raw || 'This city').trim();
  const di = r.indexOf('-');
  return { city: di >= 0 ? r.slice(0, di).trim() : r, area: di >= 0 ? r.slice(di + 1).trim() : '' };
}

// A circular preview-image pin at the model's coordinates; clicking it opens a
// popup with the city/area name (mirrors the old card) linking to the model.
function makeMarker(loc) {
  const el = document.createElement('button');
  el.type = 'button';
  el.className = 'cc-map-pin';
  el.setAttribute('aria-label', loc.name || '');
  const inner = document.createElement('span');
  inner.className = 'cc-map-pin__inner';
  const img = document.createElement('img');
  img.src = loc.imgSmall || loc.img || ''; img.alt = loc.name || ''; img.loading = 'lazy';
  inner.appendChild(img);
  el.appendChild(inner);

  const pop = document.createElement('div');
  pop.className = 'cc-map-pop';

  const eyebrow = document.createElement('span');
  eyebrow.className = 'smallcaps text-subdued cc-map-pop__eyebrow';
  eyebrow.textContent = window.CF?.T?.cube_custom?.from_main || 'From our main collection';

  const { city, area } = splitName(loc.name);
  const title = document.createElement('span');
  title.className = 'h6 cc-map-pop__title';
  title.appendChild(document.createTextNode(city));
  if (area) {
    const areaEl = document.createElement('span');
    areaEl.style.fontWeight = '300';
    areaEl.textContent = ' ' + area;
    title.appendChild(areaEl);
  }

  const view = document.createElement('a');
  view.className = 'button button--sm cc-map-pop__view';
  view.href = loc.url || '#';
  view.target = '_blank';
  view.rel = 'noopener';
  view.textContent = window.CF?.T?.cube_custom?.view_model || 'View';

  const thumb = document.createElement('img');
  thumb.className = 'cc-map-pop__thumb';
  thumb.src = loc.img || '';
  thumb.alt = loc.name || '';
  thumb.loading = 'lazy';

  const textWrap = document.createElement('span');
  textWrap.className = 'cc-map-pop__text';
  textWrap.appendChild(eyebrow);
  textWrap.appendChild(title);
  if (loc.magnetic) {
    const mag = document.createElement('span');
    mag.className = 'size-info-magnetic smallcaps cc-map-pop__magnetic';
    mag.textContent = loc.magnetic;
    textWrap.appendChild(mag);
  }

  const body = document.createElement('span');
  body.className = 'cc-map-pop__body';
  body.appendChild(textWrap);
  body.appendChild(view);   // View button sits BELOW the text
  pop.appendChild(thumb);
  pop.appendChild(body);

  const popup = new mapboxgl.Popup({ offset: 32, closeButton: true, closeOnClick: true, closeOnMove: true, className: 'cc-map-popup', maxWidth: '340px' }).setDOMContent(pop);
  return new mapboxgl.Marker({ element: el, anchor: 'center' }).setLngLat([loc.lon, loc.lat]).setPopup(popup);
}

function clearAll() {
  markers.forEach(m => m.remove());
  markers.clear();
}

// Show pins only for models inside the current map view (refreshed on move),
// so the map stays clean and only ever holds a handful of DOM markers.
function update() {
  const map = window.CF_CUBE_CUSTOM_MAP?.getMap?.();
  if (!map || typeof mapboxgl === 'undefined' || typeof map.getBounds !== 'function') return;
  if (map.getZoom() < MIN_ZOOM) { clearAll(); return; }
  const b = map.getBounds();
  const inView = LOCS.filter(l => b.contains([l.lon, l.lat])).slice(0, MAX_PINS);
  const keep = new Set(inView.map(l => l.url));
  markers.forEach((m, url) => { if (!keep.has(url)) { m.remove(); markers.delete(url); } });
  for (const l of inView) {
    if (!markers.has(l.url)) markers.set(l.url, makeMarker(l).addTo(map));
  }
}

document.addEventListener('cf:cube:map-moved', update);
document.addEventListener('cf:cube:map-flystart', clearAll);
update();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();
/* Deep-link arrival.
 *
 * TWO keys, in strict priority:
 *   ?design=<id>  — the design's OWN identity. Resolved via GET /design/{id},
 *                   which answers for in-flight renders too, and then ATTACHED
 *                   to. Nothing is generated.
 *   ?lat&lon&…    — the geometry. Used to position the map, and as the fallback
 *                   that regenerates when the id can't be resolved.
 *
 * Why id-first: the coordinate path resumes a design by re-POSTing /preview and
 * trusting the server to re-hash identical inputs back to the same design_id.
 * Reconstructing an identity through the map, the URL and a float round-trip is
 * lossy — any drift silently forked a SECOND render of the default map location
 * instead of resuming the first. The id can't drift.
 *
 * The coordinate path is kept, not replaced: links sent before design= existed
 * are coords-only, and an evicted or pre-RENDER_VERSION-bump design must still
 * regenerate rather than dead-end.
 */
(() => {
const p = new URLSearchParams(location.search);
const designId = (p.get('design') || '').trim();
const lat = parseFloat(p.get('lat'));
const lon = parseFloat(p.get('lon'));
const hasCoords = Number.isFinite(lat) && Number.isFinite(lon);
if (!designId && !hasCoords) return;

const scale = parseFloat(p.get('scale'));
const rotation = parseFloat(p.get('rotation'));
// The emailed "saved design" link carries saved=1 — the model already exists,
// so we skip the map step and open straight on step 3 (ATC).
const jumpToOrder = p.get('saved') === '1';
const saved = {
  lat, lon,
  scale: Number.isFinite(scale) ? scale : undefined,
  rotation: Number.isFinite(rotation) ? rotation : undefined,
};

// Once the map has settled at the saved location, generate (a cache hit, since
// the design already exists) and advance to step 2 — where the shopper picks
// Trees/Streets — the moment the preview lands (was step 3 / order).
function autoOrder() {
  let jumped = false;
  document.addEventListener('cf:cube:preview-ready', function onReady() {
    if (jumped) return;
    jumped = true;
    document.removeEventListener('cf:cube:preview-ready', onReady);
    requestAnimationFrame(() => {
      document.querySelector('.cf-v2-step[data-v2-step="2"]')?.click();
    });
  });
  window.CF._skipNearbyGate = true;   // restoring a saved design — skip the gate
  window.CF._silentRestore  = true;   // splash covers the wait — suppress the gen animation
  // Generate from the EXACT saved coordinates (from the URL), NOT the live map
  // center: the map's flyTo can settle ~1 km off, and generating from that drift
  // spawns a NEW near-duplicate design instead of reproducing the SAME design_id
  // and continuing the in-flight job. One-shot; handleGetPreview consumes+clears.
  window.CF._restoreCoords = {
    lat: lat, lon: lon,
    scale: Number.isFinite(scale) ? scale : undefined,
    rotation: Number.isFinite(rotation) ? rotation : undefined,
  };
  document.getElementById('cube-custom-get-preview')?.click();
}

// ── id-first resolve ──────────────────────────────────────────────────────
// Returns the action that attaches to the existing design - run at once, the map
// is placed behind it - or null to fall through to the coordinate path
// (regenerate). The record is usually asked for already by the section's first
// script (window.CF._designFetch), while the page was still coming in.
async function resolveDesign() {
  const base = ((window.CF && window.CF.CONSTANTS && window.CF.CONSTANTS.PREVIEW_API_URL) || '').replace(/\/$/, '');
  if (!designId || !base) return null;
  let d;
  const early = window.CF && window.CF._designFetch;
  if (early && early.id === designId) {
    d = await early.promise;
  } else {
    try {
      const res = await fetch(`${base}/design/${encodeURIComponent(designId)}`);
      if (!res.ok) return null;
      d = await res.json();
    } catch (_) { return null; }
  }
  if (!d || !d.design_id) return null;

  // Evicted, cancelled, or a render that died without artifacts → there is
  // nothing to attach to. `stale` means the artifacts predate the current
  // RENDER_VERSION: attaching would pin this link to an outdated image
  // forever, so we let the coordinate path re-render it under the new token.
  if (d.status === 'gone' || d.stale) return null;

  // Prefer the design's OWN recorded geometry over the URL's — the URL can be
  // hand-edited or stale, the server's copy is what the render actually used.
  const r = d.request || {};
  if (Number.isFinite(r.lat) && Number.isFinite(r.lon)) {
    saved.lat = r.lat; saved.lon = r.lon;
    if (Number.isFinite(r.scale))    saved.scale = r.scale;
    if (Number.isFinite(r.rotation)) saved.rotation = r.rotation;
  }

  if (d.status === 'pending') {
    return () => {
      // Pass the server's own geometry so a registry entry created here (shared
      // link, fresh browser) carries the coords its toast link needs. No place
      // name is available — the server doesn't store one — and an empty title is
      // far better than the map's default city.
      window.CF.CUBE_PREVIEW?.watchPending?.(d.design_id, {
        lat: saved.lat, lon: saved.lon, scale: saved.scale, rotation: saved.rotation,
      });
      settled({});   // nothing to buffer yet — the design has no preview
    };
  }
  if (d.status === 'ready') {
    return () => {
      const cfg = d.config || {};
      window.CF.CUBE_PREVIEW?.showDesign?.({
        design_id: d.design_id, preview_url: d.preview_url,
        lat: saved.lat, lon: saved.lon, scale: saved.scale, rotation: saved.rotation,
        trees: !!cfg.trees, streets: !!cfg.streets,
        cover: cfg.cover || 'none', plaque: cfg.plaque || 'none',
        plaque_headline: cfg.plaque_headline || '',
        plaque_subheadline: cfg.plaque_subheadline || '',
        marker: cfg.marker || null,
      });
      // Real detail, so the gallery buffers this design into "Your Designs" —
      // the coordinate path got that for free from onReady.
      settled({ design_id: d.design_id, preview_url: d.preview_url });
      if (jumpToOrder) requestAnimationFrame(() => {
        document.querySelector('.cf-v2-step[data-v2-step="2"]')?.click();
      });
    };
  }
  return null;
}

// The splash lifts on cf:cube:preview-ready, and the gallery buffers off it.
// The attach paths never run a generation, so nothing else would fire it and
// the splash would sit there until its 6 s safety timeout.
function settled(detail) {
  document.dispatchEvent(new CustomEvent('cf:cube:preview-ready', { detail: detail || {} }));
}

let applied = false;
async function apply() {
  if (applied) return;
  const api = window.CF_CUBE_CUSTOM_MAP;
  if (!api || typeof api.applySavedState !== 'function') return;
  if (!api.getState || !api.getState().center) return;  // map not ready yet
  applied = true;
  document.removeEventListener('cf:cube:map-moved', apply);

  const attach = await resolveDesign();
  // The design shows at once: the preview step does not show the map, so
  // waiting for it to load and reach the place (it used to) only held the
  // design back, 0.4-3 s (2026-10-26). The map is placed behind it.
  if (attach) attach();
  // Fall back to regenerating from coordinates only when we actually have them
  // and the shopper arrived on a saved link; otherwise just place the map.
  const onSettled = attach ? undefined : (jumpToOrder && hasCoords ? autoOrder : undefined);
  if (!Number.isFinite(saved.lat) || !Number.isFinite(saved.lon)) {
    if (onSettled) onSettled();
    return;
  }
  api.applySavedState({ ...saved, onSettled });
}
document.addEventListener('cf:cube:map-moved', apply);
document.addEventListener('DOMContentLoaded', apply);
apply();
})();
/* Model feedback (preview step), in TWO steps against the same design.
 *
 * Step 1 — the note. Text only, no email: leaving it must cost nothing.
 * Step 2 — appears ONLY after step 1 is stored. Offers the paid hand-refinement
 *          service and asks for an email (+ optional scope detail).
 *
 * Both POST to the same endpoint, which APPENDS to the design's feedback list
 * (never overwrites); `kind` ("feedback" / "quote") is what separates them on
 * the dashboard. Step 2 is a strictly separate request, so a shopper who reads
 * the offer and closes the panel has still left their note.
 *
 * Self-contained; reads the API base + design id lazily so script order doesn't
 * matter. Drives BOTH the CUBE and FRAME configurators — they render identical
 * ids, only the copy differs. */
(function () {
const root = document.getElementById('cf-feedback');
if (!root) return;
const toggle = document.getElementById('cf-feedback-toggle');
const panel  = document.getElementById('cf-feedback-panel');
const textEl = document.getElementById('cf-feedback-text');
const sendBtn = document.getElementById('cf-feedback-send');
if (!toggle || !panel || !textEl || !sendBtn) return;
// Step 2. Absent on any older markup that still renders only the note, in which
// case everything below degrades to exactly the previous single-step behaviour.
const quoteStep = document.getElementById('cf-feedback-step-quote');
const emailEl   = document.getElementById('cf-feedback-email');
const qTextEl   = document.getElementById('cf-feedback-quote-text');
const qSendBtn  = document.getElementById('cf-feedback-quote-send');
const qDoneEl   = document.getElementById('cf-feedback-quote-done');
const hasQuote  = !!(quoteStep && emailEl && qSendBtn);

const sendLabel = sendBtn.textContent.trim();
const sentLabel = sendBtn.getAttribute('data-sent-label') || 'Feedback sent';
const qSendLabel = hasQuote ? qSendBtn.textContent.trim() : '';
const qSentLabel = hasQuote ? (qSendBtn.getAttribute('data-sent-label') || qSendLabel) : '';
const apiBase = () => ((window.CF && window.CF.CONSTANTS && window.CF.CONSTANTS.PREVIEW_API_URL) || '').replace(/\/$/, '');
const currentDid = () => (window.CF_CUBE_CUSTOM_PREVIEW && window.CF_CUBE_CUSTOM_PREVIEW.design_id) || null;
// Deliberately loose — the server validates properly. This only decides when to
// enable the button, so it must not reject addresses the server would accept.
const emailOk = (v) => /^[^@\s]+@[^@\s.]+(\.[^@\s.]+)+$/.test((v || '').trim());

// The form is reused as the shopper regenerates. `formDid` tracks which design
// the current input/state belongs to; when they open the form for a DIFFERENT
// design we reset it (so a "sent" state or an old draft never leaks across
// designs), but reopening for the SAME design keeps their draft — including a
// revealed step 2, so the offer doesn't vanish while they think about it.
let formDid = null;
function reset() {
  sendBtn.textContent = sendLabel;
  sendBtn.disabled = true;
  textEl.value = ''; textEl.readOnly = false;
  if (!hasQuote) return;
  quoteStep.hidden = true;
  qSendBtn.textContent = qSendLabel;
  qSendBtn.disabled = true;
  emailEl.value = ''; emailEl.readOnly = false;
  if (qTextEl) { qTextEl.value = ''; qTextEl.readOnly = false; }
  if (qDoneEl) qDoneEl.hidden = true;
}

toggle.addEventListener('click', function () {
  const opening = panel.hidden;
  if (opening) {
    const did = currentDid();
    if (did !== formDid) { reset(); formDid = did; }
  }
  panel.hidden = !opening;
  toggle.setAttribute('aria-expanded', String(opening));
  if (opening) textEl.focus();
});

textEl.addEventListener('input', function () {
  if (textEl.readOnly) return;              // already sent
  sendBtn.disabled = !textEl.value.trim();
});

// The store the shopper is on, so a quote can be written in the currency they
// were shown: Shopify's localization country and currency (window.CF.LOCALE),
// plus the country's English name — the server has no country table, and the
// staff mail is in English whatever language the storefront is in.
function storeContext() {
  const L = (window.CF && window.CF.LOCALE) || {};
  const code = String(L.countryCode || '').toUpperCase();
  let name = '';
  try {
    if (code && window.Intl && Intl.DisplayNames) {
      name = new Intl.DisplayNames(['en'], { type: 'region' }).of(code) || '';
    }
  } catch (e) { /* an unknown code: the server shows the code alone */ }
  return {
    store_country: code || undefined,
    country_name: name || undefined,
    currency: L.currency || undefined,
  };
}

// POST one entry. Resolves true on success; the callers own the UI state so a
// failure leaves the shopper able to retry rather than stuck on "sent".
async function post(did, payload) {
  const base = apiBase();
  if (!did || !base) return false;
  try {
    const res = await fetch(base + '/design/' + encodeURIComponent(did) + '/feedback', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign(storeContext(), payload)),
    });
    return res.ok;
  } catch (e) {
    return false;
  }
}

sendBtn.addEventListener('click', async function () {
  const text = (textEl.value || '').trim();
  const did = currentDid();
  if (!text) return;
  sendBtn.disabled = true;
  const ok = await post(did, { feedback: text, kind: 'feedback' });
  if (!ok) { sendBtn.disabled = false; return; }   // let them retry
  formDid = did;
  sendBtn.textContent = sentLabel;         // "Feedback sent"
  textEl.readOnly = true;
  if (!hasQuote) return;
  // The note is stored — now make the offer.
  quoteStep.hidden = false;
  emailEl.focus();
});

if (hasQuote) {
  emailEl.addEventListener('input', function () {
    if (emailEl.readOnly) return;           // already sent
    qSendBtn.disabled = !emailOk(emailEl.value);
  });

  qSendBtn.addEventListener('click', async function () {
    const email = (emailEl.value || '').trim();
    const did = currentDid();
    if (!emailOk(email)) return;
    qSendBtn.disabled = true;
    const ok = await post(did, {
      feedback: (qTextEl && qTextEl.value.trim()) || '',   // optional scope detail
      email: email,
      kind: 'quote',
    });
    if (!ok) { qSendBtn.disabled = false; return; }        // let them retry
    qSendBtn.textContent = qSentLabel;
    emailEl.readOnly = true;
    if (qTextEl) qTextEl.readOnly = true;
    if (qDoneEl) qDoneEl.hidden = false;
  });
}
})();
